module.exports = __webpack_public_path__ + "media/images/buriel-8-9c431a76bc11ee7ef166bdd62b73919f.png";